<router-outlet></router-outlet>
<app-overlay></app-overlay>
<app-overlay #userNotification></app-overlay>
<app-overlay #inaction></app-overlay>
<ng-container *ngIf="viewSnow">
    <app-snow (snowChanges)="checkSnow($event)"></app-snow>
</ng-container>
